import { Subject as d, filter as p, tap as f, take as l } from "rxjs";
import { getPelandoLoadingGif as A } from "../../../../services/url/index.js";
function w(m) {
  return (i) => {
    const u = i.import(
      "formats/image"
    ), c = new d(), n = async (s, e) => {
      const t = await fetch(e).then((b) => b.blob()), r = new File([t], "sample.png", { type: t.type }), o = await m(r);
      return c.next({ id: s, src: o }), o;
    };
    class a extends u {
      static create(e) {
        const t = super.create(e);
        return typeof e == "string" ? (n("abc", t.getAttribute("src") || "").then((r) => (t.setAttribute("src", r), t)), t) : (c.pipe(
          p((r) => r.id === e.id),
          f((r) => {
            t.setAttribute("src", r.src);
          }),
          l(1)
        ).subscribe(), t.setAttribute("src", e.src), t.setAttribute("crossorigin", "true"), t.classList.add("custom-image"), t.setAttribute("id", e.id), t);
      }
    }
    function g(s) {
      s.clipboard.addMatcher("IMG", (e, t) => {
        var r;
        return e.tagName === "IMG" && ((r = e.getAttribute("src")) != null && r.startsWith("data:image")) ? (t.ops = [], n("abc", e.getAttribute("src") || ""), t.insert({
          image: {
            id: "abc",
            src: A()
          }
        })) : t;
      });
    }
    return a.blotName = "image", a.tagName = ["img"], i.register("formats/image", a), i.register("modules/imageHandler", g), {
      modules: {
        imageHandler: !0
      }
    };
  };
}
export {
  w as PasteImageExtension
};
